/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DefaultCurrencyEnum } from './DefaultCurrencyEnum';
import {
    DefaultCurrencyEnumFromJSON,
    DefaultCurrencyEnumFromJSONTyped,
    DefaultCurrencyEnumToJSON,
    DefaultCurrencyEnumToJSONTyped,
} from './DefaultCurrencyEnum';
import type { DefaultTimeFormatEnum } from './DefaultTimeFormatEnum';
import {
    DefaultTimeFormatEnumFromJSON,
    DefaultTimeFormatEnumFromJSONTyped,
    DefaultTimeFormatEnumToJSON,
    DefaultTimeFormatEnumToJSONTyped,
} from './DefaultTimeFormatEnum';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';

/**
 * 
 * @export
 * @interface PatchedTeam
 */
export interface PatchedTeam {
    /**
     * 
     * @type {number}
     * @memberof PatchedTeam
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedTeam
     */
    name?: string;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof PatchedTeam
     */
    readonly members?: Array<Membership>;
    /**
     * Return permission group names for the request user in this org.
     * 
     * Degrades gracefully to empty list on any error to avoid crashing
     * the org list endpoint.
     * @type {Array<string>}
     * @memberof PatchedTeam
     */
    readonly permissionGroups?: Array<string>;
    /**
     * Return resolved permissions for the request user in this org.
     * 
     * Returns list of {entity_type_name, event_type_name} dicts.
     * Degrades gracefully to empty list on any error.
     * @type {Array<{ [key: string]: any; }>}
     * @memberof PatchedTeam
     */
    readonly permissions?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedTeam
     */
    readonly hasActiveSubscription?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PatchedTeam
     */
    readonly isPayingCustomer?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PatchedTeam
     */
    readonly footerGateEnforced?: boolean;
    /**
     *
     * @type {DefaultCurrencyEnum}
     * @memberof PatchedTeam
     */
    defaultCurrency?: DefaultCurrencyEnum;
    /**
     *
     * @type {DefaultTimeFormatEnum}
     * @memberof PatchedTeam
     */
    defaultTimeFormat?: DefaultTimeFormatEnum;
    /**
     * Entity ID for org-level visibility associations
     * @type {string}
     * @memberof PatchedTeam
     */
    readonly entityId?: string | null;
    /**
     * Slack channel URL for design partner communication
     * @type {string}
     * @memberof PatchedTeam
     */
    readonly slackChannelUrl?: string;
}



/**
 * Check if a given object implements the PatchedTeam interface.
 */
export function instanceOfPatchedTeam(value: object): value is PatchedTeam {
    return true;
}

export function PatchedTeamFromJSON(json: any): PatchedTeam {
    return PatchedTeamFromJSONTyped(json, false);
}

export function PatchedTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(MembershipFromJSON)),
        'permissionGroups': json['permission_groups'] == null ? undefined : json['permission_groups'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'hasActiveSubscription': json['has_active_subscription'] == null ? undefined : json['has_active_subscription'],
        'isPayingCustomer': json['is_paying_customer'] == null ? undefined : json['is_paying_customer'],
        'footerGateEnforced': json['footer_gate_enforced'] == null ? undefined : json['footer_gate_enforced'],
        'defaultCurrency': json['default_currency'] == null ? undefined : DefaultCurrencyEnumFromJSON(json['default_currency']),
        'defaultTimeFormat': json['default_time_format'] == null ? undefined : DefaultTimeFormatEnumFromJSON(json['default_time_format']),
        'entityId': json['entity_id'] == null ? undefined : json['entity_id'],
        'slackChannelUrl': json['slack_channel_url'] == null ? undefined : json['slack_channel_url'],
    };
}

  export function PatchedTeamToJSON(json: any): PatchedTeam {
      return PatchedTeamToJSONTyped(json, false);
  }

  export function PatchedTeamToJSONTyped(value?: Omit<PatchedTeam, 'id'|'members'|'permissionGroups'|'permissions'|'hasActiveSubscription'|'isPayingCustomer'|'footerGateEnforced'|'entityId'|'slackChannelUrl'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'default_currency': DefaultCurrencyEnumToJSON(value['defaultCurrency']),
        'default_time_format': DefaultTimeFormatEnumToJSON(value['defaultTimeFormat']),
    };
}

